import checkIsTicketGroupOnSale from '@dashboard/services/event/checkIsTicketGroupOnSale';
import checkIsTicketGroupScheduled from '@repo/checkout/lib/checkIsTicketGroupScheduled';
import checkIsTicketGroupSoldOut from '@repo/checkout/lib/checkIsTicketGroupSoldOut';
import checkIsTicketGroupNotOnSale from '@repo/checkout/lib/checkIsTicketGroupNotOnSale';

export function getGroupStatus({ ticketGroup, page, allTicketGroups }) {
  if (ticketGroup.status === 'archived') return { text: 'Group archived', badge: null };
  if (ticketGroup.status === 'disabled') return { text: null, badge: null };

  const isOnSale = checkIsTicketGroupOnSale({ page, ticketGroup, allTicketGroups });
  const isSoldOut = checkIsTicketGroupSoldOut(ticketGroup, { excludeTicketTypes: true });
  const { isScheduled } = checkIsTicketGroupScheduled({ ticketGroup, allTicketGroups });

  if (isSoldOut) return { text: null, badge: { status: 'sold_out', label: 'Sold out' } };
  if (ticketGroup.availabilityStatus === 'unavailable')
    return { text: null, badge: { status: 'unavailable', label: 'Unavailable' } };
  if (ticketGroup.availabilityStatus === 'available' && !isOnSale && isScheduled)
    return { text: 'Group scheduled', badge: null };
  if (isOnSale) return { text: 'Group on sale', badge: null };
  return { text: 'Group not on sale', badge: null };
}

export function getGroupHiddenTooltip({ ticketGroup, page, allTicketGroups }) {
  if (ticketGroup.hidden) return 'This ticket group is hidden';

  const isOnSale = checkIsTicketGroupOnSale({ page, ticketGroup, allTicketGroups });
  const isSoldOut = checkIsTicketGroupSoldOut(ticketGroup, { excludeTicketTypes: true });
  const isUnavailable = ticketGroup.availabilityStatus === 'unavailable';
  const { isScheduled, hasInvalidReference } = checkIsTicketGroupScheduled({
    ticketGroup,
    allTicketGroups,
  });
  const isNotOnSale = checkIsTicketGroupNotOnSale({
    ticketGroup,
    isCanceled: page.eventDetails?.status === 'canceled',
    hasInvalidReference,
    isOnSale,
    isScheduled,
  });

  if (ticketGroup.hideWhenNotOnSale && isNotOnSale)
    return 'This ticket group is hidden when not on sale';
  if (ticketGroup.hideWhenScheduled && isScheduled)
    return 'This ticket group is hidden when scheduled to go on sale';
  if (ticketGroup.hideWhenUnavailable && isUnavailable)
    return 'This ticket group is hidden when unavailable';
  if (ticketGroup.hideWhenSoldOut && isSoldOut) return 'This ticket group is hidden when sold out';

  return null;
}
